import { useAuthStore } from '../stores/auth';
import { resolveProfile } from '../lib/profileAccess';
import ScrapManagementPage from '../pages/manufacturing/ScrapManagementPage';
import { ProfileStoreStock } from './ProfileStoreStock';
export function ProfileScrapRoute(){return resolveProfile(useAuthStore(s=>s.user))==='P14'?<ProfileStoreStock scrapOnly/>:<ScrapManagementPage/>;}
